const Footer = () => {
  return (
    <div className="bg-black px-12 md:px-28 py-2">
      <div className="flex flex-col text-center space-x-4 justify-center md:flex-row">
        <code className="font-bold text-white">
          Designed and built by Xelem
        </code>
        <code className="font-bold text-white">&copy; 2023</code>
      </div>
      <div className="flex space-x-4 justify-center pt-2">
        <a
          href="https://www.linkedin.com/in/xelem/"
          className="p-1 bg-gray-900 rounded-full"
        >
          <img
            src="linkedin.png"
            alt="linkedin"
            className="w-4 h-4 rounded-full"
          />
        </a>
        <a
          href="https://twitter.com/xel_em_"
          className="p-1 bg-gray-900 rounded-full"
        >
          <img
            src="twitter.png"
            alt="twitter"
            className="w-4 h-4 rounded-full"
          />
        </a>
        <a
          href="https://wa.me/+2348132530997"
          className="p-1 bg-gray-900 rounded-full"
        >
          <img
            src="whatsapp-icon.png"
            alt="whatsapp"
            className="w-4 h-4 rounded-full"
          />
        </a>
        <a
          href="https://github.com/Xelem"
          className="p-1 bg-gray-900 rounded-full"
        >
          <img src="github.png" alt="github" className="w-4 h-4 rounded-full" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
